import { IMeeetingAgenda } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { IChangeComputedFieldsByIndexProps } from 'legacy/lut/components/widgets/public/partner360/ELT/models/IChangeComputedFieldsByIndexProps'

import { getChangedAgendaSchedule } from './getChangedAgendaSchedule'

export const getDataWithChangedFields =
  (meetingDataTime: string) =>
  ({ data }: IChangeComputedFieldsByIndexProps<IMeeetingAgenda>): IMeeetingAgenda[] => {
    return getChangedAgendaSchedule(meetingDataTime, data)
  }
